module.exports = __webpack_public_path__ + "static/media/1006137.19abac0a.png";